import React, { useEffect, useState } from 'react';
import { sportsApi } from './sportsApi';
import { displayWindow } from './sportsTime';

export default function GuideSearch({ siteId, deviceId, app, provider, timeZone, onNavigate }) {
  const [query, setQuery] = useState('');
  const [state, setState] = useState({ results: [], loading: false, error: '' });
  const enabled = Boolean(deviceId || provider);
  useEffect(() => {
    const search = query.trim();
    setState({ results: [], loading: search.length >= 2 && enabled, error: '' });
    if (search.length < 2 || !enabled) return undefined;
    let active = true; const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const scope = deviceId ? { deviceId, app: app || '' } : { kind: provider.official ? 'official' : 'external', sourceId: provider.id };
        const result = await sportsApi(siteId, `guide-search?${new URLSearchParams({ ...scope, search })}`, { signal: controller.signal });
        if (active) setState({ ...result, loading: false, error: '' });
      } catch (failure) {
        if (active) setState({ results: [], loading: false, error: failure.message });
      }
    }, 250);
    return () => { active = false; controller.abort(); clearTimeout(timer); };
  }, [query, siteId, deviceId, app, provider, enabled]);
  return <div className="lineup-epg__search" role="search" aria-label="Programme search">
    <label>Search programmes<input type="search" value={query} maxLength={100} disabled={!enabled} placeholder="Team, programme or channel…"
      onChange={(event) => setQuery(event.target.value)} /></label>
    {query && <button type="button" onClick={() => setQuery('')}>Clear search</button>}
    <p>Type at least 2 characters. Searches published listings from now through the next 14 days · {timeZone}.</p>
    {state.loading && <p role="status">Searching programmes…</p>}
    {state.error && <p role="alert">{state.error} Edit the search to try again.</p>}
    {!state.loading && !state.error && query.trim().length >= 2 && <>
      <p role="status">{state.results.length ? `${state.truncated ? 'First ' : ''}${state.results.length} matching listings${state.truncated ? ' · refine your search for more specific results' : ''}` : 'No published listings match this search.'}</p>
      <ul className="lineup-epg__search-results" aria-label="Programme search results">{state.results.map((result) => <li key={`${result.channel.id}:${result.programme.id}`}>
        <button type="button" onClick={() => { onNavigate(result); setQuery(''); }}>
          <strong>{result.programme.title}</strong>
          <span>{[result.channel.name, result.channel.appName, result.channel.deviceName].filter(Boolean).join(' · ')}</span>
          <span>{displayWindow(result.programme.startsAt, result.programme.endsAt, timeZone)}</span>
        </button>
      </li>)}</ul>
    </>}
  </div>;
}
